import EF from 'ef/ef';
import Backbone from 'backbone';
import Questions from 'ef/collections/questions';
import $ from 'jquery';
import _ from 'lodash';

/*/ ## Assessment
//
// Object for loading assessment questions. To get a login to our Survey/Assessment
// Engine please contact us at engineering@everfi.com.
//
// Some sample code for loading an assessment:
//     var assmnt = new Assessement({slug: "awesome"})
//     assmnt.loadQuestions(function(questions){
//       var assessment = this;
//       // Render the assessment
//     });
/*/
const Assessment = Backbone.Model.extend({
  // Assessment JSON endpoint is
  // http://survey.everfi.net/surveys/:survey-slug-name/questions.json
  questionsUrl: function () {
    const base = EF.config.get('assessmentEndpoint');
    return `${base}api/surveys/${this.get('slug')}/questions.json?callback=?`;
  },

  assessUrl: function () {
    const base = EF.config.get('assessmentEndpoint');
    return `${base}/surveys/assess.json?callback=?`;
  },

  // loads the assessment's question from the assessment endpoint
  // takes an options hash that may include a success callback that will be
  // called with the loaded questions
  loadQuestions: function (options) {
    const assmnt = this;
    const cb = options && options.success;
    $.getJSON(this.questionsUrl(), function (questions) {
      assmnt.questions = new Questions(questions);
      if (cb) {
        cb.apply(assmnt, [assmnt.questions]);
      }
    });
  },

  // Respond to the assessment with answers in the following format:
  //
  //     [
  //       {
  //         questionid: '123',
  //         answerid: '123'
  //       },
  //       {
  //         questionid: '123',
  //         answerid: '123'
  //       }
  //     ]
  //
  recordResponse: function (response, options) {
    const cb = options && _.bind(options.success, this);

    const responsePackage = _.map(response, function (qq) {
      return {
        id: qq.questionId,
        as: [{ id: qq.answerId }],
      };
    });

    const args = { user_id: EF.enrollment.get('id'), rs: responsePackage };
    $.getJSON(this.assessUrl(), args, cb);
  },
});

export default Assessment;
